import GtmMobileUserFeeds from 'mobile/initializers/gtm_mobile_user_feeds';
import GtmMobileWatchPage from 'mobile/initializers/gtm_mobile_watch_page';
import { isMobile } from 'shared/vidio_helpers';
import SocialTracker from 'shared/social_tracker';
import $ from 'jquery';

const SocialModal = {
  modalSelector: "#vidio-social-modal",
  closeModalSelector: ".js-social-modal__close",
  overlaySelector: ".js-social-modal__overlay",
  triggerSelector: null,
  containerSelector: null,
  isBoundClickToTrack: false,

  init: function(triggerSelector, containerSelector, tracker = SocialTracker.createNull()){
    this.triggerSelector = triggerSelector;
    this.containerSelector = containerSelector;
    this.tracker = tracker;

    this.bindOpenSocialModal();
    this.bindCloseSocialModal();
    this.bindShareUrl();
  },

  bindOpenSocialModal: function(){
    var containerSelector = this.containerSelector;
    var modalSelector = this.modalSelector;
    var openSocialModal = this.openSocialModal;
    var sendGtmPopupImpression = this.sendGtmPopupImpression;
    var sendGtmPopupShareButtonClick = this.sendGtmPopupShareButtonClick;
    var bindClickToTrack = this.bindClickToTrack.bind(this);

    $(this.triggerSelector).each(function(idx, button) {
      $(button).on("click touchend", function(e){
        e.preventDefault();
        e.stopPropagation();
        var modalContentSelector;
        var dataTarget = $(this).data('target');
        var dataSource = $(this).data('source');
        var dataVideoId = $(this).data('video-id');

        document.getElementsByTagName("body")[0].style.overflow = 'hidden';
        modalContentSelector = dataTarget ? dataTarget : containerSelector;
        openSocialModal(modalSelector, modalContentSelector);

        sendGtmPopupImpression(dataSource, dataVideoId);
        sendGtmPopupShareButtonClick(dataSource);

        // bind click always called because the DOM always replaced when showing modal 
        // (see line: 69, openSocialModal)
        bindClickToTrack();
      });
    });
  },

  bindCloseSocialModal: function(){
    $(this.closeModalSelector).click(function(e){
      e.preventDefault();
      this.closeSocialModal();
    }.bind(this));

    $(this.overlaySelector).click(function(e){
      e.preventDefault();
      this.closeSocialModal();
    }.bind(this));
  },

  openSocialModal: function(modalSelector, modalContentSelector) {
    var element = $(modalContentSelector).html();

    $(modalSelector).find(".social-modal__content").html(element);
    if(isMobile()) {
      $(modalSelector).addClass("b-popup--show");
    } else {
      $(modalSelector).addClass("social-modal__show");
    }

    if(window.player) {
      window.player.tech().pause();
    }
  },

  closeSocialModal: function(){
    if(isMobile()) {
      $(this.modalSelector).removeClass("b-popup--show");
    } else {
      $(this.modalSelector).removeClass("social-modal__show");
    }

    document.getElementsByTagName("body")[0].style.removeProperty("overflow");

    if(window.player) {
      window.player.tech().play();
    }
  },

  bindShareUrl: function(){
    $("body").on("click", ".share--text", function(e){
      e.preventDefault();
      this.select();
    });
  },

  sendGtmPopupImpression: function(source, videoId){
    if(source == 'feeds'){
      GtmMobileUserFeeds.pushWithType('impression', 'vod.'+videoId, 'share', 'following');
    } else if(source == 'vod-watchpage'){
      var properties = {
        event             : 'impression',
        feature_name      : 'share',
        feature_location  : 'watchpage',
        feature_type      : 'vod.'+videoId
      };
      GtmMobileWatchPage.sendDataLayer(properties);
    }
  },

  sendGtmPopupShareButtonClick: function(source){
    if(source == 'feeds'){
      GtmMobileUserFeeds.bindShareButtonClick('facebook');
      GtmMobileUserFeeds.bindShareButtonClick('line');
      GtmMobileUserFeeds.bindShareButtonClick('twitter');
      GtmMobileUserFeeds.bindShareButtonClick('google-plus');
      GtmMobileUserFeeds.bindShareButtonClick('whatsapp');
      GtmMobileUserFeeds.bindShareButtonClick('link');
    } else if(source == 'vod-watchpage'){
      GtmMobileWatchPage.bindShareButtonClick('facebook');
      GtmMobileWatchPage.bindShareButtonClick('line');
      GtmMobileWatchPage.bindShareButtonClick('twitter');
      GtmMobileWatchPage.bindShareButtonClick('google-plus');
      GtmMobileWatchPage.bindShareButtonClick('whatsapp');
      GtmMobileWatchPage.bindShareButtonClick('link');
    }
  },

  bindClickToTrack: function(){
    let tracker = this.tracker;
    let shareButtons = $(this.modalSelector).find('.share');
    shareButtons.each((_index, button) => {
      $(button).on("click", () => {
        let url = SocialModal.shareButtonUrl(button);
        tracker.trackShareClick(button.textContent, url);
      });
    });
  },

  shareButtonUrl: (button) => $(button).data('utm-url') || $(button).data('clipboard-text')
};

export default SocialModal;
